import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SmallLockIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5 7.08V6a3 3 0 0 1 6 0v1.08a1.5 1.5 0 0 1 1 1.415v3a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5v-3A1.5 1.5 0 0 1 5 7.08M9.5 6a1.5 1.5 0 0 0-3 0v.995h3zM8 10.995a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
		></path>
	</svg>
))
